import { ConfigProvider } from 'antd';
import ruRU from 'antd/locale/ru_RU';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import './App.css';
import { LayoutAuth } from './features/layout-auth/layout-auth';
import { PageInfo } from './page-info';
import { theme } from './theme/theme';

function App() {
  return (
    <BrowserRouter>
      <ConfigProvider locale={ruRU}>
        <ThemeProvider theme={theme}>
          <LayoutAuth>
            <Routes>
              <Route path="/" element={<PageInfo />} />
              <Route path="*" element={<PageInfo />} />
            </Routes>
          </LayoutAuth>
        </ThemeProvider>
      </ConfigProvider>
    </BrowserRouter>
  );
}

export default App;
